import type { QueryResponse } from '@/types/pipl';

export const enum ApiError {
  DEFAULT = 'Sorry, we couldn’t complete your scan. Try again later.',
  BAD_REQUEST = 'Sorry, we couldn’t complete your scan. Try to change your data and try again.',
  NO_RESPONSE = 'Sorry, we didn’t catch that. Check your connection and try again.',
  REQUEST_FAILED = 'Sorry, something went wrong on our end. Try again later.',
  NON_US_USER = 'Sorry, you must be in the U.S.A. to run a scan.',
  NO_IP_ADDRESS = 'Sorry, we couldn’t detect your location. Try again later.',

  // opt-out DBOO
  DEFAULT_DBOO = 'Sorry, we couldn’t complete your opt out request. Try again later.',
}

export type PiplError = Pick<
  QueryResponse,
  '@http_status_code' | 'warnings' | 'error'
>;

export function isPiplError(error: unknown): error is PiplError {
  return (
    typeof error === 'object' &&
    error !== null &&
    ('@http_status_code' in error || 'warnings' in error || 'error' in error)
  );
}
